"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _statusEnum = require("../../common/statusEnum");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.statusIcon svg {\n  fill: #000000; }\n\n.statusIcon.SIAred svg {\n  fill: #e41b13; }\n\n.statusIcon.SIAwhite svg {\n  fill: #fff; }\n";
  const fileName = "StatusIcon_StatusIcon";
  const element = document.querySelector("style[data-sass-component='StatusIcon_StatusIcon']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const StatusIcon = _ref => {
  let {
    className,
    status,
    color
  } = _ref;
  if (typeof status === 'string') {
    status = _statusEnum.statuses[status];
  }
  if (!status) {
    status = _statusEnum.statuses['INPROGRESS'];
  }
  let Icon = status.icon;
  let colorToUse = color || status.defaultColor;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `statusIcon ${colorToUse} ${className}`
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    "aria-label": status.description
  }));
};
exports.StatusIcon = StatusIcon;
StatusIcon.propTypes = {
  className: _propTypes.default.string,
  status: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  color: _propTypes.default.string
};